export default __webpack_public_path__ + "static/project-start1-c0b26d36f041b54574abf171dcdea67c.png";